"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadShifts = void 0;
const const_1 = require("@app/const");
const globals_1 = require("@app/const/globals");
const util_1 = require("@app/util");
const moment_1 = __importDefault(require("moment"));
const set_shifts_1 = __importDefault(require("../action/set-shifts"));
const shifts_1 = __importDefault(require("../request/shifts"));
const store_1 = __importDefault(require("../store"));
const is_loading_1 = __importDefault(require("./is-loading"));
const load_event_warnings_1 = __importDefault(require("./load-event-warnings"));
const create_ac_1 = require("./util/create-ac");
exports.loadShifts = (0, create_ac_1.createAC)(async (dispatch, { period, users, warningsHidden, locality, forManagerCalendar }) => {
    const { auth, workspaceId, shifts, workspaces } = store_1.default.getState();
    if (!workspaceId || !period)
        return;
    const ws = workspaces?.find((w) => w.id === workspaceId);
    // get the shifts for the period from BE
    dispatch((0, is_loading_1.default)('load-shifts'));
    let resultShifts = await (0, shifts_1.default)({
        id: workspaceId,
        period,
        user: !users ? undefined : typeof users === 'string' ? users : undefined,
        users: !users ? undefined : typeof users === 'string' ? undefined : users,
        locality: typeof locality !== 'undefined'
            ? locality === globals_1.NO_LOCALITY
                ? null
                : locality
            : undefined,
        useOrFilter: Boolean(typeof locality !== 'undefined' && typeof users !== 'undefined'), // we use OR (conjunction) filtering logic when we have locality and users filters enabled (this normally happens due to workspace.enforcedLocality)
    }, auth, {
        // IF we're loading shifts for manager calendar
        // AND current user has READ-ONLY calendar access
        // AND WS.settings.showOnlyCommittedInReadOnlyCalendar is true
        // THEN make sure we request only committed shifts
        includeUncommitted: forManagerCalendar && !util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.CALENDAR)
            ? !ws?.settings?.showOnlyCommittedInReadOnlyCalendar
            : undefined,
    });
    if ((0, util_1.isDefined)(resultShifts)) {
        // add all the other, previously loaded shifts to the list
        resultShifts = resultShifts.concat(shifts.filter((os) => !resultShifts?.find((rs) => rs.id === os.id)));
        dispatch((0, set_shifts_1.default)(resultShifts));
        // and asynchronously get the warnings for those shifts
        if (!warningsHidden) {
            let warningsPeriod = Object.assign({}, period);
            // skip the past shifts (if the 'attendance' plugin is not enabled)
            const ws = workspaces.find((w) => w.id === workspaceId);
            if (!ws?.plugins?.find((p) => p?.plugin === 'attendance' && p?.enabled)) {
                if ((0, moment_1.default)(warningsPeriod.start).isBefore((0, moment_1.default)().startOf('day')))
                    warningsPeriod.start = (0, moment_1.default)().startOf('day');
                if ((0, moment_1.default)(warningsPeriod.end).isSameOrBefore(warningsPeriod.start))
                    warningsPeriod = null;
            }
            if (warningsPeriod) {
                dispatch((0, load_event_warnings_1.default)(warningsPeriod, users));
            }
        }
    }
    dispatch((0, is_loading_1.default)('load-shifts', true));
    return resultShifts;
});
exports.default = exports.loadShifts;
// export default ({ period, users, warningsHidden, locality, forManagerCalendar }) => {
//   // NOTE: The 'users' prop can be either:
//   // - an array of user IDs (we only load shifts of users from that array)
//   // - a string with a single user ID (we only load shifts of that one user)
//   // - undefined/null (we load shifts of all users in the WS)
//   return async (dispatch) => {
//     const { auth, workspaceId, shifts, workspaces } = store.getState()
//     if (!workspaceId || !period) return
//     const ws = workspaces?.find((w) => w.id === workspaceId)
//     // get the shifts for the period from BE
//     dispatch(isLoading('load-shifts'))
//     let resultShifts = await requestShifts(
//       {
//         id: workspaceId,
//         period,
//         user: !users ? undefined : typeof users === 'string' ? users : undefined,
//         users: !users ? undefined : typeof users === 'string' ? undefined : users,
//         locality:
//           typeof locality !== 'undefined'
//             ? locality === NO_LOCALITY
//               ? null
//               : locality
//             : undefined,
//         useOrFilter: Boolean(
//           typeof locality !== 'undefined' && typeof users !== 'undefined'
//         ), // we use OR (conjunction) filtering logic when we have locality and users filters enabled (this normally happens due to workspace.enforcedLocality)
//       },
//       auth,
//       {
//         // IF we're loading shifts for manager calendar
//         // AND current user has READ-ONLY calendar access
//         // AND WS.settings.showOnlyCommittedInReadOnlyCalendar is true
//         // THEN make sure we request only committed shifts
//         includeUncommitted:
//           forManagerCalendar && !permissionsUtil.canWrite(PERMISSIONS.CALENDAR)
//             ? !ws?.settings?.showOnlyCommittedInReadOnlyCalendar
//             : undefined,
//       }
//     )
//     if (resultShifts.error) {
//       dispatch(addError(resultShifts.error))
//     } else {
//       // add all the other, previously loaded shifts to the list
//       resultShifts = resultShifts.concat(
//         shifts.filter((os) => !resultShifts.find((rs) => rs.id === os.id))
//       )
//       await dispatch(setShifts(resultShifts))
//       // and asynchronously get the warnings for those shifts
//       if (!warningsHidden) {
//         let warningsPeriod = Object.assign({}, period)
//         // skip the past shifts (if the 'attendance' plugin is not enabled)
//         const ws = workspaces.find((w) => w.id === workspaceId)
//         if (
//           !ws ||
//           !ws.plugins ||
//           !ws.plugins.find((p) => p.plugin === 'attendance' && p.enabled)
//         ) {
//           if (moment(warningsPeriod.start).isBefore(moment().startOf('day')))
//             warningsPeriod.start = moment().startOf('day')
//           if (moment(warningsPeriod.end).isSameOrBefore(warningsPeriod.start))
//             warningsPeriod = null
//         }
//         if (warningsPeriod) {
//           dispatch(loadEventWarnings(warningsPeriod, users))
//         }
//       }
//     }
//     dispatch(isLoading('load-shifts', true))
//     return resultShifts
//   }
// }
